import { Interpolation, Theme, useTheme } from '@emotion/react';
import { isFunction } from 'lodash';
import { DependencyList, useMemo } from 'react';

/** A hook to build memoized Emotion styles. */
export const useStyles = (styles: Interpolation<Theme>, deps: DependencyList = []) => {
  const theme = useTheme();
  return useMemo(() => (isFunction(styles) ? styles(theme) : styles), [theme, styles, ...deps]);
};
